// Generated by scripts/gen-manifest.js from schema.js. Do not edit by hand.
export const manifest = [
  {
    "name": "projects",
    "columns": [
      {
        "name": "owner_group_id",
        "type": "text",
        "isIndexed": true,
        "scope": true
      },
      {
        "name": "name",
        "type": "text"
      },
      {
        "name": "entry",
        "type": "text"
      },
      {
        "name": "kind",
        "type": "text"
      },
      {
        "name": "mode",
        "type": "text"
      },
      {
        "name": "created",
        "type": "integer"
      },
      {
        "name": "updated",
        "type": "integer"
      }
    ]
  },
  {
    "name": "files",
    "columns": [
      {
        "name": "owner_group_id",
        "type": "text",
        "isIndexed": true,
        "scope": true
      },
      {
        "name": "projectId",
        "type": "text",
        "isIndexed": true
      },
      {
        "name": "path",
        "type": "text"
      },
      {
        "name": "hash",
        "type": "json",
        "jsonSchema": {
          "type": "object",
          "properties": {
            "hash": {
              "type": "string",
              "rb": {
                "type": "text",
                "blobRef": true
              }
            },
            "size": {
              "type": "integer",
              "minimum": 0,
              "maximum": 9007199254740991
            }
          },
          "required": [
            "hash",
            "size"
          ],
          "additionalProperties": false
        }
      }
    ]
  },
  {
    "name": "versions",
    "columns": [
      {
        "name": "owner_group_id",
        "type": "text",
        "isIndexed": true,
        "scope": true
      },
      {
        "name": "projectId",
        "type": "text",
        "isIndexed": true
      },
      {
        "name": "versionId",
        "type": "text"
      },
      {
        "name": "created",
        "type": "integer"
      },
      {
        "name": "message",
        "type": "text"
      },
      {
        "name": "manifest",
        "type": "json",
        "jsonSchema": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "path": {
                "type": "string"
              },
              "hash": {
                "type": "object",
                "properties": {
                  "hash": {
                    "type": "string",
                    "rb": {
                      "type": "text",
                      "blobRef": true
                    }
                  },
                  "size": {
                    "type": "integer",
                    "minimum": 0,
                    "maximum": 9007199254740991
                  }
                },
                "required": [
                  "hash",
                  "size"
                ],
                "additionalProperties": false,
                "rb": {
                  "type": "json"
                }
              }
            },
            "required": [
              "path",
              "hash"
            ],
            "additionalProperties": false
          }
        }
      }
    ]
  },
  {
    "name": "conversations",
    "columns": [
      {
        "name": "owner_group_id",
        "type": "text",
        "isIndexed": true,
        "scope": true
      },
      {
        "name": "projectId",
        "type": "text",
        "isIndexed": true
      },
      {
        "name": "messages",
        "type": "json",
        "jsonSchema": {
          "type": "array",
          "items": {}
        }
      },
      {
        "name": "updated",
        "type": "integer"
      }
    ]
  }
]
